/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable max-len */
import * as React from "react";
import { connect } from "react-redux";
import { ProductDetail, ProductStatus, ProductTariff } from "../../../../../../store/Product/Types";
import { RemoteScope } from "../../../../../../store/RemoteTypes";
import { DispatchFunc } from "../../../../../../store/ActionTypes";
import { ReduxState } from "../../../../../../store/ReduxState";
import { UpdateEndDateModal } from "../UpdateEndDateModal";
import { UserInfo, UserRoles } from "../../../../../../store/AppTypes";
import { CoverageLevelDisplay } from "../../../../../../store/Policies/Displays";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { Modal } from "@vwpfs/mary-air-lib/components/air/06-molecules/Modal";
import { LoadingData } from "@vwpfs/mary-air-lib/components/air/09-views/00-blocks/LoadingData";
import { ThemeSize, ThemeShadowSizes, ThemePalette, ThemeBreakpoints } from "@vwpfs/mary-air-lib/theme/_Types";
import { modalShow } from "../../../../../../utils/redux/ActionTypes";
import { FlexRow } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Row";
import { FlexColumn } from "@vwpfs/mary-air-lib/components/air/03-base/Flex/Column";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Container } from "@vwpfs/mary-air-lib/components/air/03-base/Container";
import { Grid } from "@vwpfs/mary-air-lib/components/air/03-base/Grid";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { FieldSet } from "@vwpfs/mary-air-lib/components/air/06-molecules/FieldSet";
import { FormTextArea } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/TextArea";
import { FieldTypes, FormField } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field";

interface State {
    selectedIndexes: number[];
}

/**
 *
 */
interface OwnProps {
    tariffs?: ProductTariff[];
    asAudit?: boolean;
}

/**
 *
 */
interface StateProps {
    formData: ProductDetail;
    user?: UserInfo;
}

/**
 *
 */
interface DispatchProps {
    openUpdateRequest: (modalId: string, productTariff: ProductTariff, productId: string) => void;
}

/**
 *
 */
type Props = OwnProps & StateProps & DispatchProps;

/**
 *
 * @param props
 */
export class TariffsComp
    extends React.Component<Props, State> {


    public constructor(props: Props) {
        super(props);

        this.state = { selectedIndexes: [] };
        this.show = this.show.bind(this);
    }
    public static mapStateToProps(s: ReduxState): StateProps {
        return {
            formData: s.prop("remote").prop(RemoteScope.PRODUCT_DETAILS),
            user: s.prop("user").isPresent() ? s.prop("user").get() : undefined,
        };
    }

    /**
     *
     */
    public static mapDispatchToProps(dispatch: DispatchFunc): DispatchProps {
        return {
            openUpdateRequest: (modalId: string, productTariff: ProductTariff, productId: string) => dispatch(
                modalShow(
                    modalId,
                    () => (
                        <Modal
                            modalID={modalId}
                            theme={{ size: ThemeSize.SMALL }}
                        >
                            <UpdateEndDateModal
                                modalID={modalId}
                                productTariff={productTariff}
                                productId={productId}
                            />
                        </Modal>
                    ),
                ),
            ),
        };
    }


    public render() {
        const tariffs = this.props.tariffs ? this.props.tariffs : this.props.formData &&
            this.props.formData.content &&
            this.props.formData.content.productTariffs ?
            this.props.formData.content.productTariffs : undefined;
        return (
            tariffs && tariffs.length > 0 ? (
                <Div theme={{ shadow: ThemeShadowSizes.TINY }}>
                    <Container
                        theme={{
                            palette: ThemePalette.CONTRAST_PRIMARY,
                            padding: {
                                "": { y: 3 },
                                "sm": { y: 4 },
                            },
                        }}
                    >
                        {tariffs.map((tariff, index) => (
                            tariff.tariffLine && (
                                <>
                                    <Div
                                        theme={{
                                            shadow: ThemeShadowSizes.SMALL,
                                            margin: {
                                                "": { b: 2 },
                                                "sm": { b: 3 },
                                            },
                                        }}
                                        key={`tariff-${index}`}
                                    >
                                        <Container
                                            theme={{
                                                palette: ThemePalette.CONTRAST_PRIMARY,
                                                padding: {
                                                    "": { y: 3 },
                                                    "sm": { y: 4 },
                                                },
                                            }}
                                        >

                                            <Div className="scl-b-row">
                                                <Grid
                                                    size={{ xs: 12, md: 3 }}
                                                >
                                                    <FormField
                                                        label="Starting Date"
                                                        type={FieldTypes.Date}
                                                        value={tariff.startingDate}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 3 }}
                                                >
                                                    <FormField
                                                        label="Ending Date"
                                                        type={FieldTypes.Date}
                                                        value={tariff.endingDate}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 3 }}
                                                >
                                                    <FormField
                                                        type={FieldTypes.Number}
                                                        label="Duration of Insurance"
                                                        value={tariff.durationOfInsurance}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 3 }}
                                                >
                                                    <FormField
                                                        type={FieldTypes.Text}
                                                        label="Model"
                                                        value={tariff.tariffLine.model?.name}
                                                        asSummary
                                                    />
                                                </Grid>
                                            </Div>
                                            {this.state.selectedIndexes.includes(index) &&
                                        <FieldSet
                                            title={"Tariff"}
                                            key={`tariff-2${index}`}
                                        >
                                            <Div className="scl-b-row">
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        type={FieldTypes.Number}
                                                        label="Max kilometers"
                                                        value={tariff.tariffLine.maxMileage}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        type={FieldTypes.Number}
                                                        label="Period"
                                                        value={tariff.tariffLine.tariffPeriod}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        type={FieldTypes.Text}
                                                        label="Coverage level"
                                                        value={CoverageLevelDisplay[
                                                            tariff.tariffLine.coverageLevel]}
                                                        asSummary
                                                    />
                                                </Grid>
                                            </Div>
                                            <Div className="scl-b-row">
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        label="Premium"
                                                        type={FieldTypes.CurrencyDisplay}
                                                        value={tariff.tariffLine.premium}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        label="Tax"
                                                        type={FieldTypes.CurrencyDisplay}
                                                        value={tariff.tariffLine.tax}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        label="Net Premium"
                                                        type={FieldTypes.CurrencyDisplay}
                                                        value={tariff.tariffLine.netPremium}
                                                        asSummary
                                                    />
                                                </Grid>
                                            </Div>
                                            <Div className="scl-b-row">
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        label="Cost"
                                                        type={FieldTypes.CurrencyDisplay}
                                                        value={tariff.tariffLine.cost}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        label="Net Premium Excluding Cost"
                                                        type={FieldTypes.CurrencyDisplay}
                                                        value={tariff.tariffLine.netPremiumExCost}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        label="Commission VWPFS"
                                                        type={FieldTypes.CurrencyDisplay}
                                                        value={tariff.tariffLine.commissionVWPFS}
                                                        asSummary
                                                    />
                                                </Grid>
                                            </Div>
                                            <Div className="scl-b-row">
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        label="Sign committee damage"
                                                        type={FieldTypes.CurrencyDisplay}
                                                        value={tariff.tariffLine.signCommitteeDamage}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        label="Incasso provision"
                                                        type={FieldTypes.CurrencyDisplay}
                                                        value={tariff.tariffLine.incassoProvision}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        label="NetMij"
                                                        type={FieldTypes.CurrencyDisplay}
                                                        value={tariff.tariffLine.netMij}
                                                        asSummary
                                                    />
                                                </Grid>
                                            </Div>
                                            <Div className="scl-b-row">
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        label="Frontier"
                                                        type={FieldTypes.CurrencyDisplay}
                                                        value={tariff.tariffLine.frontier}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        label="Insurer"
                                                        type={FieldTypes.CurrencyDisplay}
                                                        value={tariff.tariffLine.insurer}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        type={FieldTypes.Text}
                                                        label="Vehicle Type"
                                                        value={
                                                            tariff.tariffLine.passengerVehicle
                                                                && tariff.tariffLine.commercialVehicle
                                                                ? "Passenger and Commerical"
                                                                : tariff.tariffLine.commercialVehicle
                                                                    ? "Commercial"
                                                                    : "Passenger"}
                                                        asSummary
                                                    />
                                                </Grid>
                                            </Div>
                                            <Div className="scl-b-row">

                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        type={FieldTypes.Number}
                                                        label="Max kW."
                                                        value={
                                                            tariff.tariffLine?.maxKW}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        type={FieldTypes.Number}
                                                        label="Age from"
                                                        value={tariff.ageOfVehicleFrom}
                                                        asSummary
                                                    />
                                                </Grid>
                                                <Grid
                                                    size={{ xs: 12, md: 4 }}
                                                >
                                                    <FormField
                                                        type={FieldTypes.Number}
                                                        label="Age to"
                                                        value={tariff.ageOfVehicleTo}
                                                        asSummary
                                                    />
                                                </Grid>
                                            </Div>
                                            {tariff.tariffLine.description &&
                                                <Div className="scl-b-row">
                                                    <Grid
                                                        size={{ xs: 12, md: 12 }}
                                                    >
                                                        <FormTextArea
                                                            label="Description"
                                                            value={
                                                                tariff.tariffLine?.description}
                                                            asSummary
                                                        />
                                                    </Grid>
                                                </Div>
                                            }
                                        </FieldSet>}

                                        </Container>
                                        <FlexRow>
                                            <FlexColumn
                                                theme={{
                                                    palette: ThemePalette.CONTRAST_SECONDARY,
                                                }}
                                            >
                                                <Container
                                                    theme={{
                                                        padding: { "": { y: 3 } },
                                                    }}
                                                >
                                                    <ButtonsWrapper
                                                        defaultOrientation={Orientation.HORIZONTAL}
                                                        orientations={{
                                                            [ThemeBreakpoints.XS]: Orientation.VERTICAL,
                                                            [ThemeBreakpoints.MD]: Orientation.HORIZONTAL,
                                                        }}
                                                        alignment={Alignment.RIGHT}
                                                    >
                                                        <Button
                                                            theme={{ palette: ThemePalette.CONTRAST_PRIMARY }}
                                                            className="scl-a-btn--tiny"
                                                            link={{
                                                                onClick: () => this.show(index),
                                                            }}
                                                        >
                                                            {this.state.selectedIndexes.includes(index) ? "Hide tariff details" : "Show tariff details"}
                                                        </Button>
                                                        {this.props.formData?.content.status === ProductStatus.ACTIVE &&
                                                    this.props.user?.userRole !== UserRoles.EW_ADMIN_READONLY &&
                                                        <Button
                                                            theme={{ palette: ThemePalette.BRAND_ACCENT }}
                                                            className="scl-a-btn--tiny"
                                                            link={{
                                                                onClick: () =>
                                                                    this.props.openUpdateRequest(
                                                                        "tariff",
                                                                        tariff,
                                                                        this.props.formData.content.id.toString()),
                                                            }}
                                                        >
                                                            Update Ending Date
                                                        </Button>
                                                        }
                                                    </ButtonsWrapper>
                                                </Container>
                                            </FlexColumn>
                                        </FlexRow>
                                    </Div>
                                </>)
                        ))}
                    </Container>
                </Div>
            ) : (
                <LoadingData loading={false} />
            )
        );
    }

    private show(index: number) {
        this.state.selectedIndexes.includes(index) ? this.setState({
            selectedIndexes: this.state.selectedIndexes.filter(item => item !== index),
        }) :
            this.setState({
                selectedIndexes: [...this.state.selectedIndexes, index],
            });
    }
}

/**
 *
 */
export const Tariffs = connect(
    TariffsComp.mapStateToProps,
    TariffsComp.mapDispatchToProps,
)(TariffsComp);
